import { render, staticRenderFns } from "./add-promotional.vue?vue&type=template&id=1d51463f&"
import script from "./add-promotional.vue?vue&type=script&lang=js&"
export * from "./add-promotional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports